import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { admin_service } from "src/app/admin/services/admin.service";
import { isMobile } from "src/app/core/helper/responsive-flip.helper";
// import { DOCUMENT } from "@angular/common";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-ppa-vkyc",
  templateUrl: "./ppa-vkyc.component.html",
  styleUrls: ["./ppa-vkyc.component.scss"],
})
export class PPAVkycComponent implements OnInit {
  otpSent: boolean = false;
  otpValidated: boolean = false;
  errorMessageFlag: boolean = false;
  errorMessage : any;
  OTPKey: any;
  customerID: any;
  loading: boolean = false;
  isMobile : boolean = false;
  breakpoint: number = 0;
  rhRow:number = 2;
  rhCol:number = 1;
  rowHeight:string = '2:1';
  mobileFormControl = new FormControl("", [
    Validators.required,
    Validators.pattern(/^[0-9]+$/),
    Validators.maxLength(10),
    Validators.minLength(10),
  ]);
  otpFormControl = new FormControl("", [
    Validators.required,
    Validators.pattern(/^[0-9]+$/),
    Validators.maxLength(6),
    Validators.minLength(6),
  ]);
  matcher = new MyErrorStateMatcher();

  title = "console-local-dev";
  longText: any =
    "ngTextlongTex tlongT extlong TextlongTextlongText longTex tlongTextlongText";

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private admin_service: admin_service,
    private _snackBar: MatSnackBar,
    // private document : Document
  ) {}

  ngOnInit(): void {
    this.otpSent = false;
    document.body.style.backgroundColor = "#ededed";
    this.isMobile = isMobile();
    this.isMobile==true?this.rowHeight='1:1':this.rowHeight='2:1';
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 1;
  }

  sendOtp() {
    if (!this.mobileFormControl.valid) {
      let snack = this._snackBar.open("Enter Correct Phone number", "RESET", {
        duration: 5000,
      });
      snack.onAction().subscribe(()=>{
        this.mobileFormControl.enable();
        this.mobileFormControl.patchValue('');
      })
      return;
    } else {
      const d = new Date();
      var uniqueVal = Date.now();
      var uniqueString = new String(uniqueVal);
      const tStamp = d.toISOString().slice(0, -2);
      uniqueString = uniqueString.toString();
      while (uniqueString.length > 12) {
        uniqueString = uniqueString.slice(1);
      }

      
      var mobile: any = this.mobileFormControl.value;
    
      var data = {
        SendOTPToProspectReq: {
          ReqHdr: {
            ConsumerContext: {
              RequesterID: "AOA",
            },
            ServiceContext: {
              ServiceName: "AccountOpeningService",
              ReqRefNum: uniqueString,
              ReqRefTimeStamp: tStamp,
              ServiceVersionNo: "1.0",
            },
          },
          ReqBody: {
            UniqueId: uniqueString,
            MobileNo: mobile,
            otpMessage:
              "T25lIFRpbWUgUGFzc3dvcmQgZm9yIHlvdXIgb25saW5lIFlFUyBCQU5LIGFjY291bnQgb3BlbmluZyBpcyB7MH0uIFBsZWFzZSBlbnRlciB0aGUgc2FtZSB0byBjb21wbGV0ZSB5b3VyIHRyYW5zYWN0aW9uLiBXYXJtIFJlZ2FyZHMsIFlFUyBCYW5rLiA=",
          },
        },
      };
      
      this.loading = true;
      this.admin_service.VKYCSendOTP(data).subscribe(
        (res) => {
          this.otpSent = true;
          this.mobileFormControl.disable();
          this.OTPKey = res.result.SendOTPToProspectRes.ResBody.OTPKey;
          this.customerID = res.result.SendOTPToProspectRes.ResBody.MobileNo;
          this.loading = false;
        },
        (err) => {
          
          let snack = this._snackBar.open("Error with Send OTP", "RETRY", {
            duration: 5000,
          });
          snack.onAction().subscribe(()=>{
            this.mobileFormControl.enable();
            this.mobileFormControl.patchValue('');
          })
          this.loading = false;
        }
      );
    }
  }

  verifyOtp(event:any) {
    if (!this.otpFormControl.valid) {
     
      let snack = this._snackBar.open("Enter Correct OTP", "RESET", {
        duration: 5000,
      });
      snack.onAction().subscribe(()=>{
        this.otpFormControl.enable();
        this.otpFormControl.patchValue('');
      })
      return;
    } else {
      event.target.disabled = true;
      const otpVal = this.otpFormControl.value;
      const data = {
        verifyOTP: {
          version: "1",
          customerID: this.customerID.slice(2),
          otp: {
            otpKey: this.OTPKey,
            otpValue: otpVal,
          },
        },
      };
      this.loading = true;

      this.admin_service.VKYCVerifyOTP(data).subscribe(
        (res) => {
        
          this.otpValidated = true;
          if(res?.result?.webPageUrl){
            document.location.href=res.result.webPageUrl;
            this.resetVals();
          }
          else if(!this.isEmpty(res?.result?.verifyOTPResponse?.verificationFaultReason)){
            console.log(`verificationFaultReason available`);
            this.loading = false;
            let snack = this._snackBar.open(res?.result?.verifyOTPResponse?.verificationFaultReason, "RETRY", {
              duration: 5000,
            });
            snack.onAction().subscribe(()=>{
              event.target.disabled = false;
              this.resetVals();
            })
            return;
          }
          else if(this.isEmpty(res?.result?.verifyOTPResponse?.verificationFaultReason)){
            console.log(`verificationFaultReason empty`);
            this.loading = false;
            this.errorMessage='Sorry something went wrong, Please try again';
            this.errorMessageFlag = true;
            return;
          }
        },
        (err) => {
          this.errorMessage = err.error.result.message;
          err.error.result.message ? this.errorMessage = err.error.result.message : this.errorMessage='Sorry something went wrong, Please try again';
          this.errorMessageFlag = true;
          this.loading = false;

        }
      );
    }
  }

  resetVals() {
    this.otpSent = false;
    this.otpValidated = false;
    this.errorMessageFlag = false;
    this.errorMessage = '';
    this.mobileFormControl.enable();
    this.mobileFormControl.patchValue('');
    // this.otpFormControl.enable();
    this.otpFormControl.patchValue('');
    // this.reload();
  }

  isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }  
    return true
  }
}
